import React from 'react';
import ProductComparisonDesktopItem
    from 'modules/product/views/components/product-comparison/product-comparison-desktop/components/product-comparison-desktop-item';
import ProductComparisonDesktopAttributes
    from 'modules/product/views/components/product-comparison/product-comparison-desktop/components/product-comparison-desktop-attributes';
import { ProductComparisonDataInterface } from 'modules/product/views/components/product-comparison/interfaces/product-comparison.data.interface';

import './product-comparison-desktop.scss';

const ProductComparisonDesktop: React.FC<ProductComparisonDataInterface> = ({ productName, productsSimilarPrice }) => {
    return (
        <div className="comparison-d">
            <div className="comparison-d__header">
                Produkty podobne do <span>{productName}</span>
            </div>
            <div className="comparison-d__products">
                <ProductComparisonDesktopItem products={productsSimilarPrice.products} />
            </div>
            {productsSimilarPrice.attributes && (
                <div className="comparison-d__attributes">
                    <ProductComparisonDesktopAttributes attributes={productsSimilarPrice.attributes} />
                </div>
            )}
        </div>
    );
};

export default ProductComparisonDesktop;
